module.exports = __webpack_public_path__ + "media/nicole5.076c68c0.mp3";